import { Component, OnInit } from '@angular/core';
import { CookiesLocalService } from 'src/app/service/cookies-local.service';
import { ApplicantService } from 'src/app/service/applicant.service';
import { IApplicant } from 'src/app/model/IApplicant';
import { Router } from '@angular/router';
import { DialogService } from 'src/app/service/dialog-service';

@Component({
  selector: 'app-applicant-congratulation',
  templateUrl: './applicant-congratulation.component.html',
  styleUrls: ['./applicant-congratulation.component.css']
})
export class ApplicantCongratulationComponent implements OnInit {
  applicant:IApplicant;
  admittedApplicant: any;

  constructor(private dialogService: DialogService,private router: Router,private applicantService:ApplicantService,private cookieLocal:CookiesLocalService) { }

  ngOnInit() {

   
    this.applicant=this.cookieLocal.getApplicantData();
    this.applicantService.getAdmittedApplicant(this.applicant.StudentNumber).subscribe(data=>{     
      this.admittedApplicant=data;
    },error=>{
        console.log(error);
    });
  
  }
  onDownloadSrcShuttle(){
    this.applicantService.downloadSrcShuttle().subscribe(data => {
      document.location.href = data.FilePath;
      this.dialogService.openDownloadDialog(data.FilePath)
        .afterClosed().subscribe(res => {
          if (res) { }
        });

    }, error => {
      console.log(error);
    });
  }

  onDownloadAdmissionLetter(){


    this.applicantService.downloaddmissionLetter(this.applicant.StudentNumber).subscribe(data=>{
      document.location.href = data.FilePath;
      this.dialogService.openDownloadDialog(data.FilePath)
        .afterClosed().subscribe(res => {
          if (res) { }
        });
    
    },error=>{
      console.log(error);
    });
  }
  onDownloadFeeSchedule(){
   
    this.applicantService.downloadAdmissionFeeSchdule().subscribe(data=>{
      document.location.href = data.FilePath;
      this.dialogService.openDownloadDialog(data.FilePath)
        .afterClosed().subscribe(res => {
          if (res) { }
        });
    },error=>{
      console.log(error);
    })
  }
  onDownloadItems(){
    this.applicantService.downloadAdmissionItemsNeeded().subscribe(data=>{
      document.location.href = data.FilePath;
      this.dialogService.openDownloadDialog(data.FilePath)
        .afterClosed().subscribe(res => {
          if (res) { }
        });
    },error=>{
      console.log(error);
    })
  }
}
